/**
 * KAN-880, KAN-911: взят ли клиент в работу. "Отработано" (Успех / Не успех)
 * доступно только взятому: до взятия только "Взять / Назначить в работу",
 * иначе менеджер не назначается. Одно правило для таблицы CRM, панели
 * карточки доски, блока "Требуют внимания" дашборда и приложения менеджера /m.
 * Дату взятия считает backend (attention.taken_at_of) и отдаёт полем taken_at.
 */
import type { AttentionAction } from '@/services/api/dashboard';

/** Метка взятия есть (поле taken_at строки CRM, элемента внимания, карточки клиента). */
export function isTakenToWork(item: { taken_at?: string | null } | null | undefined): boolean {
  return !!item?.taken_at;
}

const OUTCOME_ACTIONS: readonly AttentionAction[] = ['success', 'refused'];
const TAKE_ONLY: readonly AttentionAction[] = ['done'];

/**
 * KAN-911: кнопки строки "Требуют внимания": взят и исход не выставлен -
 * success, refused (взятый клиент снова требует внимания); иначе только
 * done (взять в работу). Поле outcome отсутствует: как open.
 */
export function attentionRowActions(item: {
  taken_at?: string | null;
  outcome?: string;
}): readonly AttentionAction[] {
  const decided = item.outcome === 'won' || item.outcome === 'lost';
  return isTakenToWork(item) && !decided ? OUTCOME_ACTIONS : TAKE_ONLY;
}
